/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Ex_PressInputs */

const en_features_ex_press = /** @type {(inputs: Features_Ex_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dumbbell bench press`)
};

const pl_features_ex_press = /** @type {(inputs: Features_Ex_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyciskanie hantli`)
};

/**
* | output |
* | --- |
* | "Dumbbell bench press" |
*
* @param {Features_Ex_PressInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_ex_press = /** @type {((inputs?: Features_Ex_PressInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Ex_PressInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_ex_press(inputs)
	return en_features_ex_press(inputs)
});